import { Suspense, lazy } from "react";
import { Route, Routes } from "react-router-dom";
import Layout from "./components/common/layout";
import Loader from "./components/common/loader";
import ScrollToTop from "./components/common/scrollToTop";
import { ROUTES } from "./components/core/navigation";
import "./styles.css";

const Home = lazy(() => import("./components/home/home"));
const Contact = lazy(() => import("./components/contact/contact"));
const Features = lazy(() => import("./components/features/features"));
const Pricing = lazy(() => import("./components/pricing/pricing"));
const GetStarted = lazy(() => import("./components/get-started/getStarted"));

const PrivacyPolicy = lazy(() =>
  import("./components/privacy-policy/privacy-policy")
);
const Support = lazy(() => import("./components/support/support"));
const NotFound = lazy(() => import("./components/not-found"));

function App() {
  return (
    <Layout>
      <ScrollToTop />
      <Suspense fallback={<Loader />}>
        <Routes>
          <Route path={ROUTES.home} element={<Home />} />
          <Route path={ROUTES.contact} element={<Contact />} />
          <Route path={ROUTES.features} element={<Features />} />
          <Route path={ROUTES.pricing} element={<Pricing />} />
          <Route path={ROUTES.support} element={<Support />} />
          <Route path={ROUTES.privacyPolicy} element={<PrivacyPolicy />} />
          <Route path={ROUTES.getStarted} element={<GetStarted />} />

          <Route path={ROUTES.notFound} element={<NotFound />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Suspense>
    </Layout>
  );
}

export default App;
